module.exports = __webpack_public_path__ + "media/פ.afd8e4e1.mp3";